export default __webpack_public_path__ + "static/media/Desjardins.8985183b.png";